import cookie from 'cookie';

// Get cookies information
const parseCookies = (req) => cookie.parse(req ? req.headers.cookie || '' : document.cookie);

export default parseCookies;
